const logError = (error: Error, info: { componentStack: string }): void => {
  console.error(`Error: ${error}`);
  console.error(`Error message: ${error.message}`);
  console.error(`Error caused by: ${info.componentStack}`);
};

export default logError;
